import { TopChartSection } from './TopChartSection'
import { withTopChartSection } from './withTopChartSection'

const ConnectedTopChartSection = withTopChartSection(TopChartSection)

export { ConnectedTopChartSection as TopChartSection }
